/**
 * Decides whether a brand-new Hub user should be auto-enrolled as a CRM user
 * at first sign-in (the JIT profile creation in AuthContext.checkRole).
 *
 * Policy: everyone at Future Home Loans is a CRM user by default, so the
 * admin no longer has to manually flip the "CRM User" toggle for each new
 * hire. Enrollment is restricted to company Workspace accounts because
 * Google sign-in has no domain restriction — a stray outside Google account
 * that reaches the Hub must NOT silently gain CRM access.
 *
 * The Admin page toggle (UserAdminControls) remains the override: JIT
 * creation only runs when users/{uid} doesn't exist, so revoking CRM access
 * later sticks.
 */

export const AUTO_ENROLL_EMAIL_DOMAINS = ["future.loans"];

/**
 * @param {string|null|undefined} email - the new user's sign-in email
 * @returns {boolean} true if the user should get CRMUser: true by default
 */
export function shouldAutoEnrollCrm(email) {
  if (typeof email !== "string") return false;
  const normalized = email.trim().toLowerCase();
  return AUTO_ENROLL_EMAIL_DOMAINS.some((domain) =>
    normalized.endsWith(`@${domain}`)
  );
}
